import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10f08ede&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f08ede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f08ede')) {
      api.createRecord('10f08ede', component.options)
    } else {
      api.reload('10f08ede', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10f08ede&scoped=true", function () {
      api.rerender('10f08ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/couponList/couponFrom/index.vue"
export default component.exports